import { Component, OnInit } from '@angular/core';
import { PosService } from 'src/app/lazy/private/services/pos.service';
import { DialogComponent } from '../dialog/dialog.component';
import { DialogService } from '../dialog/dialog.service';
import { MainService } from 'src/app/services/main.service';

export interface PopUpModel {
  title: string;
}

@Component({
  selector: 'app-salesman',
  templateUrl: './salesman.component.html',
  styleUrls: ['./salesman.component.css']
})

export class SalesmanComponent extends DialogComponent<PopUpModel, boolean>
  implements PopUpModel, OnInit {

  title: string;
  result: any = { result: false, RtnItem: {} };
  sales_man: any;
  selected_sales_man: any = { Id: 0 };
  sm_Name = '';

  constructor(dialogService: DialogService, private ps: PosService, private ms: MainService) {
    super(dialogService);
  }

  ngOnInit() {
    this.loadSalesMan();
  }

  loadSalesMan() {
    const data = {
      LocationId: this.ms.getSettings().LocId,
      RequestedList: {
        Start: 0,
        FiterText: '',
        Limit: 1000,
        ItemTypeId: 1,
        CAType: 1
      }
    };
    this.ps.Get_Salesman(data).subscribe(res => {
      if (res.Success) {
        this.sales_man = res.data;
      }
    });
  }

  selectSalesMan(i) {
    this.selected_sales_man = i;
  }

  enter_Ok() {
    if (this.selected_sales_man.Id != 0) {
      this.result.result = true;
      this.result.RtnItem = this.selected_sales_man;
      this.close();
    }
  }

}
